import React, { useState, useEffect } from "react";

import { StyleSheet, View, Text, Platform } from "react-native";

import Collapsible from "../../common/Collapsible/Collapsible";
import MoodsList from "../../common/mood/MoodsList";
import ManaButton from "../../common/ManaButton";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import ManaTextInput from "../../common/ManaTextInput";

export default function AddJournalNotes({
  reflection,
  reflectionHours,
  showTutorials = false,
  tutorialStep = 0,
  saveNotes = () => {},
  onMoodSelected = () => {},
}) {
  const [textInput, setTextInput] = useState(null);
  const [note, setNote] = useState(null);
  const [mood, setMood] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const highlightStyle =
    showTutorials && tutorialStep == 1 ? appStyles.highlightJournal : null;

  useEffect(() => {
    const { edit_day } = reflection;

    // Mood & text for selected date
    const currentGem = reflectionHours[edit_day]
      ? reflectionHours[edit_day].gem || {}
      : {};

    setNote(currentGem?.text || "");
    setMood(currentGem?.mood);
    setEditMode(!showTutorials && !!(currentGem.text || currentGem.mood));

    // Autofocus on notes textbox only on edit gem
    if (reflection.autoFocus && textInput) {
      textInput.focus();
    }
  }, [reflection.edit_day]);

  const updateNotes = () => {
    if (showTutorials && tutorialStep != 2) return;

    saveNotes({
      edit_gem_mood: mood,
      edit_notes: note,
      isNew: !editMode,
    });
  };

  const onMoodPress = (m) => {
    if (showTutorials && tutorialStep != 1) return;

    setMood(m);
    if (m) {
      onMoodSelected();
    }
  };

  return (
    <View style={styles.container}>
      {reflection?.edit_time_unit ? (
        <Text style={[styles.intervalQuestion, highlightStyle]}>
          How was the {reflection?.edit_time_unit}?
        </Text>
      ) : null}

      <MoodsList selectedMood={mood} onSelect={(m) => onMoodPress(m)} />

      <Collapsible isCollapsed={!mood}>
        <ManaTextInput
          ref={(ref) => setTextInput(ref)}
          debounceDelay={10}
          name={"reflectionEditNote"}
          style={styles.input}
          multiline={true}
          numberOfLines={2}
          value={note || ""}
          onTextChanged={(text) => setNote(text)}
          placeholderTextColor="#9C9EB9"
          placeholder="Write some notes for yourself"
        />

        <View style={[styles.buttons]}>
          {/*  {editMode ? (
            <ManaButton
              onPress={addNewEntry}
              style={[styles.button, { marginRight: 8 }]}
              styleText={styles.buttonText}
              text="Add New Entry"
            />
          ) : null} */}
          <ManaButton
            isMainButton
            hideShadow
            disabled={!mood}
            onPress={updateNotes}
            style={[
              styles.button,
              showTutorials && tutorialStep == 2
                ? appStyles.highlightBorder
                : {},
            ]}
            styleText={styles.buttonText}
            text={editMode ? "Update" : "Journal"}
          />
        </View>
      </Collapsible>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderTopWidth: 1,
    borderTopColor: "#f5f5f5",
    marginTop: 8,
  },
  intervalQuestion: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    textAlign: "center",
    width: "100%",
    marginTop: 8,
    marginBottom: 6,
  },
  buttons: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  button: {
    width: 104,
    height: 32,
    borderRadius: 6,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#FFF",
  },
  input: {
    width: "auto",
    minHeight: 55,
    paddingTop: 10,
    paddingHorizontal: 12,
    marginVertical: 8,
    marginHorizontal: 16,
    borderRadius: 4,
    backgroundColor: "#F3F2F1",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.77,
    elevation: 3,
    color: AppTheme.almostBlack,
    shadowOpacity: 0,
  },
});
